<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -2 28 28"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                          d="M16 22.621l-3.521-6.795c-.007.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.082-1.026-3.492-6.817-2.106 1.039c-1.639.855-2.313 2.666-2.289 4.916.075 6.948 6.809 18.071 12.309 18.045.541-.003 1.07-.113 1.58-.346.121-.055 2.102-1.029 2.11-1.033zm-2.5-13.621c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm9 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-4.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"/>
                </svg>
            </div>
        </template>
        <div class="w-full text-sm - text-gray-500 mb-3">Please supply an email address or phone number for each person named below. Any blank lines or invalid handles will NOT be sent a request.</div>
        <div class="flex mt-2" v-for="person in this.personData">
            <div class="w-48">{{ person.name }}</div>
            <package-contact-search
                class="flex-1"
                #default="{ open, query, setQuery }"
                @selected:contact="(data) => { contactSelected(person,data) }"
                :top="true"
                :contacts="contacts"
                mode="phone"
                :show-phone="true"
            >
                <ui-input name="to" v-model="person.to"
                          placeholder="Email address or phone number..." type="text"
                          class="xl:col-span-12"
                          @input="setQuery(person.to?person.to:person.name)"
                          @focus="setQuery(person.to?person.to:person.name);open()"
                ></ui-input>
            </package-contact-search>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew, UiDataGrid, UiDataGridItem, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Send multiple signature requests'
        },
        button: {
            type: String,
            default: 'Send signature requests'
        },
        people: [],
        contacts: {}
    },
    data() {
        return {
            personData: [],
            form: new Form({}, async (form) => {
                await this.handle(this.personData, this)
            }),
        }
    },
    methods: {
        contactSelected(person, data) {
            this.personData.forEach((i) => {
                if (i.id === person.id) {
                    i.to = data.phone
                }
            })
        },
    },
    mounted() {
        this.people.forEach((i) => {
            let query = i.name.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let options = this.contacts.data.filter((contact) => {
                return query.every((token) => {
                    return (contact.name + '|' + contact.phone + '|' + contact.phone2).toLowerCase().includes(token);
                });
            })
            if (!i.signature && !i.signatureRequestedAt) {
                this.personData.push({
                    id: i.id,
                    name: i.name,
                    to: options.length === 1 ? options[0].phone : '',
                })
            }
        })
    }
}
</script>
